<template>
  <v-select 
    v-model="internalValue" 
    :items="$helper.currencyOptions" 
    item-text="name"
    item-value="value"
    outlined
    dense
    hide-details
    :no-data-text="$t('noinfo')"
    :disabled="disabled"
    v-bind="$attrs"
    v-on="$listeners"
    @change="onChange"
  >
    <template v-slot:prepend-inner>
      <img 
        :src="`/images/currency/${internalValue}.svg`" 
        class="icon-currency" 
        width="20" 
        height="20" 
        alt="currency"
      />
    </template>
    <template v-slot:item="{ item }">
      <v-list-item-avatar class="icon-currency-avatar">
        <img 
          :src="`/images/currency/${item.value}.svg`" 
          width="20" 
          height="20" 
          class="icon-currency" 
          alt="currency"
        />
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title>{{ item.name }}</v-list-item-title>
      </v-list-item-content>
    </template>
  </v-select>
</template>

<script>
export default {
  name: 'CurrencySelect',
  inheritAttrs: false,
  props: {
    value: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    internalValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    }
  },
  methods: {
    onChange(value) {
      this.$emit('change', value)
    }
  }
}
</script>

<style scoped>
.icon-currency{
  border-radius: 50%;
  margin-top: 3px;
}

.icon-currency-avatar{
  height: 20px !important;
  min-width: 20px !important;
  width: 20px !important;
  margin-right: 5px !important;
}
</style> 